// Video player module using Plyr.js
// Requires Plyr (https://plyr.io/) loaded on the page

const videoWraps = document.querySelectorAll('.c-large-media.video');
const plyrPlayers = new Map(); // Store Plyr instances by video container

videoWraps.forEach(videoWrap => {
  const videoPlayerWrap = videoWrap.querySelector('.c-video-player_wrap');
  // For Plyr embed video structure, the element with class "plyr__video-embed"
  // usually contains the iframe. We pass this div to Plyr.
  const plyrEmbedDiv = videoWrap.querySelector('.plyr__video-embed');
  const poster = videoWrap.querySelector('img');
  const playButton = videoWrap.querySelector('.c-btn');
  const videoText = videoWrap.querySelector('.c-large-media_text');
  const overlay = videoWrap.querySelector('.c-visual-overlay');

  let plyrInstance = null;

  // Prevent double-init
  if (plyrEmbedDiv && !plyrPlayers.has(plyrEmbedDiv)) {
    try {
      // Create Plyr instance for this embed (will work for YouTube/Vimeo via iframe)
      plyrInstance = new Plyr(plyrEmbedDiv, {
        // You may want to adjust options to your needs
        autoplay: false,
        controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
      });

      plyrPlayers.set(plyrEmbedDiv, plyrInstance);

      // Start paused and hidden (poster/overlay shown)
      plyrInstance.pause();
      if (videoPlayerWrap) {
        videoPlayerWrap.style.zIndex = -5;
      }
    } catch (error) {
      console.error('Error initializing Plyr:', error);
    }
  } else if (plyrEmbedDiv) {
    // Plyr instance already present
    plyrInstance = plyrPlayers.get(plyrEmbedDiv);
  }

  if (plyrInstance && playButton) {
    playButton.addEventListener('click', () => {
      // Animate out play button
      gsap.to(playButton, {
        opacity: 0,
        duration: 1,
        ease: 'power2.inOut',
        onComplete: () => {
          playButton.style.display = 'none';
        },
      });

      // Animate out text
      if (videoText) {
        gsap.to(videoText, {
          opacity: 0,
          duration: 1,
          ease: 'power2.inOut',
          onComplete: () => {
            videoText.style.display = 'none';
          },
        });
      }

      // Animate out overlay
      gsap.to(overlay, {
        opacity: 0,
        duration: 1,
        ease: 'power2.inOut',
        onComplete: () => {
          overlay.style.display = 'none';
        },
      });

      // Animate out poster
      gsap.to(poster, {
        opacity: 0,
        duration: 1,
        ease: 'power2.inOut',
        onComplete: () => {
          if (videoPlayerWrap) {
            videoPlayerWrap.style.zIndex = 1;
          }
          if (poster) {
            poster.style.display = 'none';
          }
        },
      });

      // Start playing (autoplay)
      plyrInstance.play();
    });
  }
});